import React, { useEffect, useRef } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Store from '../../store/Store'
import { Footer } from '../layout/Footer'
import { Header } from '../layout/Header'
import { SystemStatusBanner } from '../layout/SystemStatusBanner'
import { Loading } from './Loading'
import { PopupDialog, PopupMessage } from './Popups'
import { Version } from './Version'

const BACKGROUND_PATHS = ['/contact', '/faq', '/imprint', '/access', '/policy']
const FOOTER_EXCLUDES = ['/search', '/mapEdit', '/order']

function scrollToPageTop() {
	window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
	document.documentElement.scrollTop = 0
	document.body.scrollTop = 0
}

export default function Layout() {
	const navigate = useNavigate()
	const isLoaded = Store.use('isLoaded')
	const location = useLocation()
	const previousPathRef = useRef(location.pathname)

	useEffect(() => {
		Store.navigate = navigate
		Store.init()
	}, [navigate])

	useEffect(() => {
		const prev = previousPathRef.current
		const curr = location.pathname

		if (prev.startsWith('/booking') && !curr.startsWith('/booking')) {
			Store.resetBookingData()
		}

		previousPathRef.current = curr
	}, [location.pathname])

	useEffect(() => {
		scrollToPageTop()
	})

	if (!isLoaded) return <Loading spinner />

	const showBg = BACKGROUND_PATHS.includes(location.pathname)
	const showFooter = !FOOTER_EXCLUDES.includes(location.pathname)

	return (
		<>
			<div className="app-body items-center">
				<div className="page">
					<Header logo back menu />
					<SystemStatusBanner />

					<div
						className={
							'outlet-wrapper' +
							(showFooter ? ' outlet-wrapper-with-footer' : '') +
							(location.pathname === '/login' ? ' center-outlet-wrapper' : '')
						}
						style={showBg ? { position: 'relative' } : {}}
					>
						{showBg && (
							<div
								style={{
									position: 'absolute',
									left: 0,
									bottom: 0,
									width: '50vw',
									minWidth: 320,
									maxWidth: 900,
									background:
										"url('/assets/homepage-group.svg') no-repeat left bottom",
									backgroundSize: 'contain',
									aspectRatio: '1.3/1',
								}}
							/>
						)}

						<div
							className="self-center md:self-auto"
							style={showBg ? { position: 'relative', zIndex: 1 } : {}}
						>
							<Outlet />
						</div>
					</div>

					<Footer />
				</div>
			</div>

			<PopupDialog />
			<PopupMessage />

			<Version
				label={
					'Version: ' +
					(Store.config?.version ?? '') +
					(Store.user
						? ` (${Store.user.agentType}: ${Store.user.firstName} ${Store.user.lastName})`
						: '')
				}
			/>
		</>
	)
}
